import React from 'react';
import type { TranscriptEntry } from './useDavyAgentCall';

export function Avatar({ small = false }: { small?: boolean }) {
  const size = small ? 'h-16 w-16' : 'h-36 w-36';
  const inner = small ? 'left-[5px] top-[5px] h-[54px] w-[54px]' : 'left-3 top-3 w-[120px] h-[120px]';
  return (
    <div className={`${size} relative rounded-full shrink-0`}>
      <div className={`absolute ${inner} rounded-full overflow-hidden`} style={{ background: '#770032' }}>
        <img src="/davy-5665cdbf.png" alt="Davy" className="w-full h-full object-cover" />
      </div>
    </div>
  );
}

export function MessageBubble({ entry }: { entry: TranscriptEntry }) {
  const isUser = entry.source === 'user';
  return (
    <div className={`flex flex-col ${isUser ? 'items-end pl-8' : 'items-start pr-8'}`}>
      <div
        className={`flex max-w-[560px] flex-col gap-1 p-4 ${isUser
          ? 'rounded-bl-2xl rounded-br-[2px] rounded-tl-2xl rounded-tr-2xl'
          : 'rounded-bl-[2px] rounded-br-2xl rounded-tl-2xl rounded-tr-2xl'
        }`}
        style={{ backgroundColor: isUser ? '#CC0044' : '#FFFFFF' }}
      >
        <p className="text-sm leading-5" style={{ color: isUser ? '#FFFFFF' : '#161618', fontWeight: 450, letterSpacing: '-0.084px' }}>
          {entry.message}
        </p>
        <p className="text-xs uppercase leading-4" style={{ color: isUser ? '#FFFFFF' : '#7E7F81', fontWeight: 450, letterSpacing: '0.72px' }}>
          {entry.timestamp.toLocaleTimeString('en-IE', { hour: '2-digit', minute: '2-digit' })}
        </p>
      </div>
    </div>
  );
}
